import type { GetStaticProps } from 'next'
import ImageBanner from '@components/ImageBanner'
import type { pageTitle, pageContent } from '@lib/types'
import { CarouselBasic } from '@components/Carousels'
import { getPageTitleContentFromDB, getPageContentFromDB } from '@lib/pagequerys'
import { Container, Heading, Section, Text } from '@components/SectionComponents'


// Gets static props from DB
export const getStaticProps: GetStaticProps = async () => {

  const pageIdDB: number = 8;

  // query DB for page title data
  const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

  // Array of pageContent - query DB for pageContent data
  const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

  return {
    props: {
      pageTitle,
      pageContent,
    }
  }
}

// Home Page takes a pageTitle, and pageContent array
export default function Page({ pageTitle, pageContent }: {
  pageTitle: pageTitle,
  pageContent: pageContent[],
}) {

  return (
    <>

      <ImageBanner title={pageTitle} isHome={false} />

      {/* Section 0 */}
      <Section colour='brown'>
        <Container>
          <Heading h1={true} content={{ title: pageContent[0].title }} />
          <Text content={pageContent[0].text} />
        </Container>
        <CarouselBasic images={pageContent[1].carouselImages} overlap='bottom' />
      </Section>

      {/* Section 1 */}
      <Section colour='white'>
        <Container longer='both'>
          <Heading content={{ title: pageContent[1].title }} />
          <Text content={pageContent[1].text} />
        </Container>
        <CarouselBasic images={pageContent[2].carouselImages!} overlap='bottom' />
      </Section>

      {/* Section 2 */}
      <Section colour='cream'>
        <Container>
          <Heading content={{ title: pageContent[2].title }} />
          <Text content={pageContent[2].text} margin='end'/>
        </Container>
      </Section>

    </>
  )
}

//Meta Data
Page.title = "Our Story";
Page.description = "A beautiful hideaway nestled into the Australian bush near the famed Glass House Mountains and Sunshine Coast beaches, inspired by Steve’s life, legacy and love for wild places.";